import { constantTree } from "../../../core/events/ConstantTree";

export const evtTree = constantTree({
  TopBar: {
    Init: "",
    SelectLanguage: {
      Click: "",
      Select: "",
      Close: ""
    },
    Logo: {
      CancelPlaceSelection: "",
    },
    getCmsAppDownloadLinkAndQr: "",
    Login: {
      Click: "",
    },
    Menu: {
      Select: "",
    },
  },
  DestinationDetail: {
    Get: "",
    BookNow: {
      Click: "",
    },
    Place: {
      Get: ""
    },
    ReadMore: {
      Click: ""
    }
  },
  CMSOffers: {
    Init: "",
    FlowClose: "",
    List: {
      Get: ""
    },
    Discover: {
      Click: ""
    },
    BookNow: {
      Click: ""
    },
    Detail: {
      Back: "",
      Get: ""
    },
    BookedPass: {
      Get: "",
      Click: "",
    },
    OfferPass: {
      Click: "",
      Back: "",
      Login: "",
      ContinueAfterLogin: "",
      getOffers: "",
      Modify: {
        Click: ""
      },
      detailPage: {
        Init: "",
        customerContact: {
          Sync: ""
        }
      },
      formValuesChange: "",
      confirmPass: "",
      MonthlyPass: {},
      TravelPass: {}
    },
    BookedPassDetail: {
      Init: "",
      Back: "",
      AboutPass: "",
      Help: ""
    }
  },
  Destinations: {
    Get: "",
    Discover: {
      Click: "",
    },
  },
  GetAppBanner: {
    CrossIcon: {
      Click: "",
    },
    GetOROpenApp: {
      Click: "",
    },
    Load: {
      Session: "",
      OSInfo: "",
    },
  },
  SearchBar: {
    SelectOrigin: {
      Click: "",
      Select: "",
      Blur: "",
    },
    SelectDestination: {
      Click: "",
    },
    Stops: {
      Updated: "",
    },
    SubStations: {
      Click: "",
    },
    Favourite: {
      Click: "",
    },
    Select: {
      Switch: "",
    },
    SelectPassenger: {
      IncDecClick: "",
      OpenPopUp: "",
      Init: ""
    },
    SelectDate: {
      Open: "",
      Select: "",
      BestPrice: "",
    },
    SearchButton: {
      Click: "",
    },
    LocationMap: {
      Click: "",
    },
    FmlmSearch: {
      Click: "",
    },
    TimeSelectModal: {
      Click: "",
    },
  },
  Checkout: {
    Login: {
      Click: "",
    },
    Voucher: {
      Apply: {
        Click: "",
      },
      Input: {
        onChange: "",
      },
      Remove: {
        Click: "",
      },
      Get: ""
    },
    PromoCode: {
      Apply: {
        Click: "",
      },
      Remove: {
        Click: "",
      },
    },
  },
  NeedHelp: {
    FlowStarted: "",
    Faq: {
      Click: "",
      Get: "",
    },
    Get: {
      TicketList: "",
    },
    CustomerContact: {
      Categories: {
        Get: "",
      },
      Submit: {
        Click: "",
      },
    },
  },
  Footer: {
    Menu: {
      Select: "",
    },
  },
  Routes: {
    Get: "",
    Card: {
      Click: "",
    },
  },
  trustBuilder: {
    Get: "",
  },
  enhancedTrips: {
    Get: "",
    Details:
    {
      Click: "",
      Get: ""
    }
  },
  departureFrom:
  {
    Get: "",
  },
  todayTrainFrom:
  {
    Get: "",
  },
  favouriteTrips: {
    Get: "",
  },
  favouriteDepartures: {
    Get: "",
  },
  popularTrips: {
    Get: "",
  },
  News: {
    List: {
      Get: ""
    },
    Details: {
      Get: ""
    },
    Card: {
      Click: ""
    }
  },
  Banner: {
    List: {
      Get: ""
    },
    BookNow: {
      Click: ""
    }
  },
  helpInfo: {
    Get: "",
    Details: {
      Click: "",
      Get: ""
    }
  },
  NetowrkDetail: {
    Get: "",
    Back: "",
    Trip: {
      Click: "",
    },
  },
  Network: {
    Get: "",
    GetDetails: {
      Click: ""
    }
  },
  journeyPlannerMenu: {
    Get: "",
    shuttle: {
      bookNow: ""
    }
  },
  SelectDateModal: {
    Open: ""
  },
  AddOns: {
    Api: {
      GetBookingOffersAddOns: "",
    },
    Passenger: {
      Select: "",
      Prepare: "",
    },
    OpenPopup: {
      Click: "",
      onChange: "",
    },
    Data: {
      setExisting: "",
      reset: "",
      Confirm: "",
      CarLicensePlate: {
        Change: "",
      },
    },
    Flow: {
      Start: ""
    }
  },
  MultiBookNow: {
    Click: ""
  }
});
